export { formatCurrency } from '../PropertyDetails/PropertyDetail.utils';

/** Fallback if the offering API is unreachable. */
export const DEFAULT_MIN_INVESTMENT = 50000;

/**
 * Generate sensible preset buttons from the offering's minimum.
 * Returns 4 amounts: 1×, 2×, 3×, 4× the minimum, plus the custom field.
 */
export function buildPresetAmounts(min: number): number[] {
  return [min, min * 2, min * 3, min * 4];
}

/** Steps the user actively navigates through (excludes system transition states). */
export const NAVIGABLE_STEPS = [
  'welcome',
  'eligibility',
  'amount',
  'paymentMethod',
  'bankSelect',
  'review',
  'subscription',
  'docEsign',
  'signature',
] as const;
export type NavigableStep = (typeof NAVIGABLE_STEPS)[number];
